import { Route, Routes } from "react-router-dom";
import { useContext } from "react";

import { UserContext } from "features/account";
import ProtectedRoutes from "./utils/ProtectedRoutes";

import { individualRoutesOpen, individualRoutesProtected } from "app/routes/individualRoutes";
import { partnerRoutesOpen, partnerRoutesProtected } from "app/routes/partnerRoutes";
import { mainRoutesOpen, mainRoutesProtected } from "app/routes/mainRoutes";

const ConditionalRoutes = () => {
  const { userType } = useContext(UserContext);

  return (
    <div>
      <Routes>
        {mainRoutesOpen}
        {userType === "individual" ? individualRoutesOpen : partnerRoutesOpen}
        <Route element={<ProtectedRoutes/>}>
          {mainRoutesProtected}
          {userType === "individual" ? individualRoutesProtected : partnerRoutesProtected}
        </Route>
      </Routes>
    </div>
  );
};

export default ConditionalRoutes;
